import React from "react";

import Doctor from "./../../../assets/images/Icons/Doctor.svg";

//Style
import { MDBRow, MDBCol } from "mdbreact";
import "./Post.scss";
import PostItem from "./PostItem/PostItem";

const Post = () => {
  return (
    <MDBRow className="post mt-1">
      <MDBCol>
        <PostItem
          Profile={Doctor}
          Name={"أ. معتز احمد"}
          PostTime={"قبل ٣ ساعات"}
          PostImage={"https://mdbootstrap.com/img/Photos/Others/images/43.jpg"}
        />
        <PostItem
          Profile={Doctor}
          Name={"أ. معتز احمد"}
          PostTime={"قبل ٣ ساعات"}
          PostImage={"https://mdbootstrap.com/img/Photos/Others/images/43.jpg"}
          PostText={
            "من المهم جدا تجنب الخروج والحرص على البقاء في المنازل، نحن في ذروة انتشار المرض"
          }
        />
        <PostItem
          Profile={Doctor}
          Name={"أ. معتز احمد"}
          PostTime={"قبل ٣ ساعات"}
          PostText={
            "من المهم جدا تجنب الخروج والحرص على البقاء في المنازل، نحن في ذروة انتشار المرض"
          }
        />
      </MDBCol>
    </MDBRow>
  );
};

export default Post;
